var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24547 0.775168L8.28082 0.810524L1.45799 7.70678L1.40882 7.69768L1.40881 7.69775L0.955736 10.1445L1.0049 10.1537L0.955736 10.1446C0.935183 10.2556 0.970571 10.3697 1.05044 10.4495C1.1304 10.5295 1.24449 10.5648 1.35542 10.5443L3.80207 10.0911L3.80213 10.0911C3.8684 10.0787 3.93317 10.0454 3.98213 9.99639C3.98213 9.99639 3.98213 9.99638 3.98213 9.99638L10.7241 3.25394C11.1586 2.81942 11.1587 2.116 10.7241 1.68142L9.8179 0.775171C9.38433 0.3416 8.67904 0.341621 8.24547 0.775168ZM1.72102 9.7789L1.96455 8.46373L3.0361 9.53535L1.72102 9.7789ZM2.23106 7.76016L7.92616 2.06461L9.43472 3.57329L3.73962 9.26882L2.23106 7.76016ZM10.239 2.76892L9.91973 3.08826L8.41116 1.57958L8.73048 1.26023C8.89652 1.09418 9.16679 1.09416 9.33287 1.26023L10.239 2.16648C10.4055 2.33299 10.4055 2.60239 10.239 2.76892Z",
    fill: "#A0AEC0",
    stroke: "#A0AEC0",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.b04090b806b19913e959455faea6d795.svg";
export { ForwardRef as ReactComponent };